function initState() {
  const home = {
    item_caption: "首页",
    item_name: "首页",
    item_key: "webframe.self.home"
  }
  state.tags.push(home)
  state.activeTag = home
}
const state = {
  tags: [],
  activeTag: null
}
initState()
// 同步改变state的数据 commit来触发
const mutations = {
  resetTags( state, tags) { 
    state.tags=tags
  },
  // 新增tag
  addTag(state, tag) {
    state.tags.push(tag)
    this.commit('tagStore/changeActiveTag', tag)
  },
  // 移除tag
  removeTag(state, tag) {
    // 先找出tag在tags中的索引, 然后把activeTag设置为这个索引减去1的tag
    const index = state.tags.findIndex(item => item.item_key === tag.item_key)
    if (index !== -1) {
      state.tags = state.tags.filter((item) => item.item_key !== tag.item_key)
    }
  },
  changeActiveTag(state, tag) {
    state.activeTag = tag
  }

}
// 异步改变 dispatch来触发
const actions = {

}
const getters = {
  tags: state => {
    return state.tags
  },
  activeTag: state => {
    return state.activeTag
  }
}
const Store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
export default Store



// WEBPACK FOOTER //
// ./src/store/modules/tag.js